import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { AuthHelpAppleRestoreItemDiv } from './AuthHelpAppleRestoreItemDiv';
import { AuthHelpGoogleHuaweiRestoreItemDiv } from './AuthHelpGoogleHuaweiRestoreItemDiv';
import { AuthHelpSameAccountItemDiv } from './AuthHelpSameAccountItemDiv';

const getAuthType = (auth?: string) => {
  if (auth === 'google') {
    return 'Google ID';
  }
  if (auth === 'huawei') {
    return 'Huawei ID';
  }
  if (auth === 'apple') {
    return 'Apple ID';
  }
  if (auth === 'vk') {
    return 'ВК ID';
  }
  if (auth === 'yandex') {
    return 'Яндекс ID';
  }
  return '';
};

const getAuthTypeRf = (auth?: string) => auth === 'vk' || auth === 'yandex';

const getAuthType2 = (auth?: string) => {
  if (auth === 'android') {
    return 'Google ID';
  }
  if (auth === 'huawei') {
    return 'Huawei ID';
  }
  if (auth === 'apple') {
    return 'Apple ID';
  }
  return '';
};

const showChooseOtherDevice = (auth?: string) =>
  auth !== 'vk' && auth !== 'yandex';

const showChooseVkYa = (authAppleGoogleHuawey?: string) =>
  authAppleGoogleHuawey === 'no';

const showChooseAppleGoogleHuawet = (device: string, auth?: string) =>
  (auth === 'google' && device === 'android') ||
  (auth === 'huawei' && device === 'huawei') ||
  (auth === 'apple' && device === 'apple');

const yesNoOptions = [
  { value: 'no', label: 'Нет' },
  { value: 'yes', label: 'Да' },
];

interface QuestionProps {
  id: string;
  number: number;
  title: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options: { value: string; label: string }[];
  deviceOptions?: boolean;
}

const AuthHelpQuestion = ({
  id,
  number,
  title,
  value,
  onChange,
  options,
  deviceOptions = false,
}: QuestionProps) => (
  <FormControl
    component="fieldset"
    sx={{ width: '100%', minWidth: 0, m: 0, p: 0, border: 0 }}
  >
    <FormLabel
      component="legend"
      id={id}
      sx={{
        width: '100%',
        p: 0,
        mb: 1.5,
        color: '#29252f',
        '&.Mui-focused': { color: '#29252f' },
      }}
    >
      <Box
        component="span"
        sx={{
          display: 'grid',
          gridTemplateColumns: '24px minmax(0, 1fr)',
          gap: 1,
          alignItems: 'baseline',
        }}
      >
        <Box
          component="span"
          sx={{ color: '#8b249f', fontSize: '12px', fontWeight: 700 }}
        >
          {number}.
        </Box>
        <Box
          component="span"
          sx={{
            fontFamily: 'Comfortaa',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: 1.7,
          }}
        >
          {title}
        </Box>
      </Box>
    </FormLabel>
    <RadioGroup
      aria-labelledby={id}
      value={value}
      onChange={onChange}
      sx={{
        display: 'grid',
        gridTemplateColumns: deviceOptions
          ? 'repeat(3, minmax(0, 1fr))'
          : 'repeat(2, minmax(0, 1fr))',
        gap: 1,
      }}
    >
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          labelPlacement={deviceOptions ? 'bottom' : 'end'}
          control={
            <Radio
              size="small"
              sx={{
                p: 1,
                color: '#8c8592',
                '&.Mui-checked': { color: '#3c6b88' },
              }}
            />
          }
          label={
            <Typography
              component="span"
              fontSize="14px"
              fontWeight={value === option.value ? 700 : 500}
              lineHeight={1.6}
            >
              {option.label}
            </Typography>
          }
          sx={{
            m: 0,
            minWidth: 0,
            minHeight: deviceOptions ? 76 : 48,
            px: 0.5,
            py: deviceOptions ? 0.75 : 0,
            boxSizing: 'border-box',
            justifyContent: 'center',
            borderRadius: '6px',
            border: '1px solid',
            borderColor: value === option.value ? '#adcad8' : '#dcd9e2',
            bgcolor: value === option.value ? '#eaf2f5' : '#fff',
            '&:hover': { bgcolor: '#f1f5f7' },
            '&:focus-within': {
              outline: '2px solid #699db8',
              outlineOffset: 2,
            },
          }}
        />
      ))}
    </RadioGroup>
  </FormControl>
);

AuthHelpQuestion.defaultProps = {
  deviceOptions: false,
};

export const AuthHelpDiv = () => {
  const { authId } = useParams();
  const [valuePhone, setValuePhone] = useState('apple');
  const [valueYaVk, setValueYaVk] = useState('yes');
  const [valueAppleGoogle, setValueAppleGoogle] = useState('yes');
  const [showInstruct, setShowIntruct] = useState(false);
  const headingRef = useRef<HTMLHeadingElement>(null);

  const handleChangePhone = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValuePhone(event.target.value);
  };
  const handleChangeYaVk = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValueYaVk(event.target.value);
  };
  const handleChangeAppleGoogle = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValueAppleGoogle(event.target.value);
  };

  const changehow = () => {
    setShowIntruct((previous) => !previous);
    requestAnimationFrame(() => {
      headingRef.current?.focus({ preventScroll: true });
      headingRef.current?.scrollIntoView({ block: 'start' });
    });
  };

  const sameProviderDevice = showChooseAppleGoogleHuawet(valuePhone, authId);
  const showDeviceQuestion = showChooseOtherDevice(authId);
  const showSameAccountQuestion = showDeviceQuestion && sameProviderDevice;
  const showYaVkQuestion =
    showChooseVkYa(valueAppleGoogle) || !sameProviderDevice;
  const yaVkQuestionNumber =
    Number(showDeviceQuestion) + Number(showSameAccountQuestion) + 1;
  const showSetupYaVk = valueYaVk === 'no' && showYaVkQuestion;
  const showAppleRestore =
    (valueAppleGoogle === 'no' || !sameProviderDevice) &&
    !getAuthTypeRf(authId) &&
    authId === 'apple';
  const showSameAccountInstruction =
    getAuthTypeRf(authId) || (authId === 'apple' && !showAppleRestore);

  return (
    <Stack
      sx={{
        minHeight: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: '#fff',
        color: '#29252f',
        fontFamily: 'Comfortaa',
        '& .MuiTypography-root': { fontFamily: 'inherit', letterSpacing: 0 },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          width: '100%',
          maxWidth: 560,
          boxSizing: 'border-box',
          px: 2,
          py: 3,
          flexShrink: 0,
        }}
      >
        <Typography
          ref={headingRef}
          tabIndex={-1}
          component="h1"
          fontSize="20px"
          fontWeight={700}
          lineHeight={1.5}
          sx={{ outline: 'none', scrollMarginTop: 24 }}
        >
          {showInstruct
            ? 'Инструкция для активации подписки на двух устройствах'
            : 'Подписка на двух устройствах'}
        </Typography>

        {!showInstruct && (
          <>
            <Stack
              direction="row"
              spacing={1.25}
              alignItems="center"
              sx={{
                p: 1.5,
                bgcolor: '#eaf2f5',
                borderLeft: '3px solid #4f8298',
              }}
            >
              <AccountCircleOutlinedIcon
                sx={{ color: '#3c6b88', fontSize: 24, flexShrink: 0 }}
              />
              <Stack spacing={0.25}>
                <Typography
                  component="p"
                  fontSize="12px"
                  lineHeight={1.6}
                  color="#66616e"
                >
                  На этом устройстве вы вошли через
                </Typography>
                <Typography
                  component="p"
                  fontSize="15px"
                  lineHeight={1.6}
                  fontWeight={700}
                >
                  {getAuthType(authId)}
                </Typography>
              </Stack>
            </Stack>

            {showDeviceQuestion && (
              <AuthHelpQuestion
                id="auth-help-device"
                number={1}
                title="На каком втором устройстве подключить подписку?"
                value={valuePhone}
                onChange={handleChangePhone}
                deviceOptions
                options={[
                  { value: 'apple', label: 'Apple' },
                  { value: 'android', label: 'Android' },
                  { value: 'huawei', label: 'Huawei' },
                ]}
              />
            )}
            {showSameAccountQuestion && (
              <>
                <Divider />
                <AuthHelpQuestion
                  id="auth-help-same-account"
                  number={2}
                  title={`Можете ли вы на втором устройстве войти через тот же ${getAuthType2(
                    valuePhone
                  )}?`}
                  value={valueAppleGoogle}
                  onChange={handleChangeAppleGoogle}
                  options={yesNoOptions}
                />
              </>
            )}
            {showYaVkQuestion && (
              <>
                {showDeviceQuestion && <Divider />}
                <AuthHelpQuestion
                  id="auth-help-yandex-vk"
                  number={yaVkQuestionNumber}
                  title="Есть ли на втором устройстве вход через Яндекс ID или ВК ID?"
                  value={valueYaVk}
                  onChange={handleChangeYaVk}
                  options={yesNoOptions}
                />
              </>
            )}
          </>
        )}

        {showInstruct && (
          <>
            {showSameAccountInstruction && (
              <AuthHelpSameAccountItemDiv
                provider={getAuthType(authId)}
                showSetup={showSetupYaVk}
              />
            )}
            {showAppleRestore && (
              <AuthHelpAppleRestoreItemDiv showSetup={showSetupYaVk} />
            )}
            {(authId === 'google' || authId === 'huawei') && (
              <AuthHelpGoogleHuaweiRestoreItemDiv
                authType={authId}
                sameAccount={sameProviderDevice && valueAppleGoogle === 'yes'}
                showSetup={showSetupYaVk}
              />
            )}
          </>
        )}
      </Stack>

      <Box
        component="footer"
        sx={{
          position: 'sticky',
          bottom: 0,
          zIndex: 1,
          width: '100%',
          maxWidth: 560,
          boxSizing: 'border-box',
          px: 2,
          pt: 2,
          pb: 'calc(16px + env(safe-area-inset-bottom, 0px))',
          bgcolor: '#fff',
          borderTop: '1px solid #e5e2e9',
          flexShrink: 0,
        }}
      >
        <Button
          variant="contained"
          fullWidth
          disableElevation
          startIcon={showInstruct ? <ArrowBackRoundedIcon /> : undefined}
          endIcon={!showInstruct ? <ArrowForwardRoundedIcon /> : undefined}
          onClick={changehow}
          sx={{
            minHeight: 52,
            py: 1.5,
            px: 2,
            borderRadius: '8px',
            bgcolor: '#8b249f',
            fontFamily: 'inherit',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: 1.6,
            letterSpacing: 0,
            textTransform: 'none',
            '&:hover': { bgcolor: '#742084' },
            '&.Mui-focusVisible': {
              outline: '3px solid #adcad8',
              outlineOffset: 3,
            },
          }}
        >
          {showInstruct ? 'Закрыть инструкцию' : 'Получить инструкцию'}
        </Button>
      </Box>
    </Stack>
  );
};
